import React from "react";
import moment from "moment/min/moment-with-locales";
import { Button } from "primereact/button";
import i18n from "../../i18n";

import calendar from "../../images/Icons/calendar.svg";
import hospital from "../../images/Icons/lucide_hospital.svg";
import doctor from "../../images/Icons/hugeicons_doctor.svg";

import "./ExternalStudyCard.css";

const ExternalStudyCard = ({ pedido, parent }) => {
    const exibirNomePaciente = parent.RetPerfil() !== "Paciente" || parent.state.isAcessoCompartilhado;

    return (
        <div className="external-study-card-root">
            <div className="StudyArea--pedidoExterno">
                <div className="StudyArea-Left">
                    <div className="PacienteDados">
                        <div className="PacienteDados-Exame"></div>

                        <div className="PacienteDados-Exame">
                            {exibirNomePaciente && (
                                <>
                                    <b>{pedido.Paciente.Nome}</b>
                                    <b> | </b>
                                </>
                            )}
                            <b>{pedido.Procedimento.Nome}</b>
                        </div>

                        <div className="StudyArea--pedidoExterno--dados">
                            {(parent.state.infoDataAtivoMedico) && (
                                <div className="DataExame">
                                    <img src={calendar} style={{ marginRight: "5px" }} /> {i18n.t("PORTAL.CARD.DATE")}: <b>{moment(pedido.DataEstudo).format("DD/MM/YYYY")}</b>
                                </div>
                            )}

                            {(parent.state.infoUnidadeAtivoPaciente) && (
                                <div className="Unidade">
                                    <img src={hospital} style={{ marginRight: "5px" }} />
                                    {i18n.t("PORTAL.EXTERNAL.CLINIC_HOSPITAL")} <b>{pedido.Unidade.Nome}</b>
                                </div>
                            )}

                            {(parent.state.infoMedSolicitanteAtivoPaciente) && (
                                <div className="MedicoSolicitante">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {parent.state.labelInfoMedSolicitante || i18n.t("PORTAL.CARD.REQUESTING_DOCTOR")} <b>{pedido.MedicoSolicitante.Nome}</b>
                                </div>
                            )}
                        </div>

                        <div className="StudyArea--pedidoExterno--buttons">
                            <div>
                                {(pedido.imagemPreviewUrl) && (
                                    <Button
                                        className="BtnImagens"
                                        type="text"
                                        tooltipOptions={{ position: "bottom" }}
                                        icon="custom-icon"
                                        tooltip={i18n.t("PORTAL.EXTERNAL.IMAGES")}
                                        iconpos="right"
                                        label={i18n.t("PORTAL.EXTERNAL.IMAGES")}
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, "Imagens")}
                                    />
                                )}
                            </div>

                            <div>
                                {(pedido?.Files?.length > 0) && (
                                    <Button
                                        className="btnAnexos"
                                        type="text"
                                        tooltipOptions={{ position: "bottom" }}
                                        icon="custom-icon"
                                        tooltip={i18n.t("PORTAL.EXTERNAL.FILES")}
                                        iconpos="right"
                                        label={i18n.t("PORTAL.EXTERNAL.FILES")}
                                        onClick={() => parent.handleAbrirModalGenerica(pedido, "Arquivos")}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {pedido.imagemPreviewUrl ? (
                    <div className="StudyArea-Right">
                        <div className="StudyPreview">
                            <div className="StudyPreview-Image">
                                <img
                                    src={pedido.imagemPreviewUrl}
                                    alt={i18n.t("PORTAL.CARD.PREVIEW_ALT")}
                                    onClick={() => parent.handleAbrirModalGenerica(pedido, "Imagens")}
                                    onLoad={(e) => e.target.style.opacity = 1}
                                    style={{
                                        width: "223px",
                                        height: "232px",
                                        borderRadius: "15px",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        transition: "opacity 0.3s ease-in-out"
                                    }}
                                />

                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : pedido.imagemPreviewUrl === undefined ? (
                    <div className="StudyArea-Right">
                        <div className="StudyPreview">
                            <div className="StudyPreview-Image">
                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {pedido.imagemPreviewUrl ? (
                    <div className="StudyArea-Preview">
                        <div className="StudyPreview-tablet">
                            <div className="StudyPreview-Image">
                                <img
                                    src={pedido.imagemPreviewUrl}
                                    alt={i18n.t("PORTAL.CARD.PREVIEW_ALT")}
                                    onClick={() => parent.handleAbrirModalGenerica(pedido, "Imagens")}
                                    onLoad={(e) => e.target.style.opacity = 1}
                                    style={{
                                        width: "160px",
                                        height: "168px",
                                        borderRadius: "15px",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0,
                                        transition: "opacity 0.3s ease-in-out"
                                    }}
                                />

                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : pedido.imagemPreviewUrl === undefined ? (
                    <div className="StudyArea-Preview">
                        <div className="StudyPreview-tablet">
                            <div className="StudyPreview-Image">
                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ExternalStudyCard;
